import styled from 'styled-components'

export const Content = styled.div`
  overflow-wrap: anywhere;
  white-space: pre-wrap;
`
